import type { App } from 'vue'
import { setupScrollDirectives } from './scroll'

export const setupDirectives = (app: App) => {
  setupScrollDirectives(app)
} 